import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from './../models/api-response.model';
import { Dropdown } from './../models/dropdown.model';
import { BankAccount } from '@core/models/bank-account.model';

@Injectable({
  providedIn: 'root'
})
export class MemberBankHttpService {

  constructor(private http: HttpClient) { }

  getMemberBanks(): Observable<Dropdown[]> {
    return this.http.get<ApiResponse>(`/bankaccount`).pipe(
      map(res => res.data.rows)
    );
  }

  getverificationDetails(): Observable<any> {
    return this.http.get<ApiResponse>(`/bankaccount/verificationdetails`).pipe(
      map(res => res.data)
    );
  }

}
